import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  drawerHeader: {
    defaultMessage: 'Apply for Fulfilled by ShipStation',
    id: 'JcS55i',
    description: 'Header for the application form drawer',
  },
  formTitle: {
    defaultMessage:
      "Apply today by completing this form. We'll review your information to see if Fulfilled by ShipStation is a match for your needs.",
    description: 'Title and subtitle for the application form',
    id: 'HL92d8',
  },
  closeDrawerButtonAriaLabel: {
    defaultMessage: 'Close application form',
    description: 'Aria label for the close button on the application drawer',
    id: 'PR2NB7',
  },
  back: {
    defaultMessage: 'Back',
    description: 'Back button text',
    id: 'WDROA9',
  },
  submit: {
    defaultMessage: 'Submit',
    description: 'Submit button text',
    id: 'QOOtMh',
  },
  close: {
    defaultMessage: 'Close',
    description: 'Close button text',
    id: '4BH2f8',
  },
  submissionSuccessTitle: {
    defaultMessage: 'Thank you for applying!',
    description: 'Title for the submission success message',
    id: 'cFEOsa',
  },
  submissionSuccessBody: {
    defaultMessage: 'We are working on reviewing your application and will reach out with next steps if you qualify.',
    description: 'Body for the submission success message',
    id: 'P/5Xsf',
  },
  applicationSubmissionFailedTitle: {
    defaultMessage: 'Application Submission Failed',
    description: 'Title for the application submission failed notification',
    id: 'IA8Gnq',
  },
  applicationSubmissionFailedContent: {
    defaultMessage: 'There was an error submitting your FBS application. Please try again.',
    description: 'Content for the application submission failed notification',
    id: '1q1TSK',
  },
});
